<script
    src="../../../../../../../../../Downloads/vuejs-validation-tutorial-master/vuejs-validation-tutorial-master/src/main.js"
></script>
<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3>{{ phase }} Phase</h3>
      </div>
      <div class="card-body">
        <validation-observer ref="simpleRules">
          <b-form>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label for="startDate">Start Date</label>
                  <validation-provider
                    #default="{ errors }"
                    name="startDate"
                    rules="required"
                  >
                    <template>
                      <b-form-datepicker
                        v-model="phaseTwo.startDate"
                        :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                        menu-class="w-100"
                        calendar-width="100%"
                      />
                    </template>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="startDate">Planned End Date</label>
                  <validation-provider
                    #default="{ errors }"
                    name="plannedEndDate"
                    rules="required"
                  >
                    <template>
                      <b-form-datepicker
                        id="plannedEndDate"
                        v-model="phaseTwo.plannedEndDate"
                        :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                        menu-class="w-100"
                        calendar-width="100%"
                      />
                    </template>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label for="startDate">Actual End Date</label>
                  <validation-provider
                    #default="{ errors }"
                    name="actualEndDate"
                    rules="required"
                  >
                    <template>
                      <b-form-datepicker
                        v-model="phaseTwo.actualEndDate"
                        :class="errors&&errors.length > 0 ? 'is-invalid' : 'valid'"
                        menu-class="w-100"
                        calendar-width="100%"
                      />
                    </template>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="type">Revisions</label>
                  <a
                    v-if="parentObj2 && parentObj2.revision && parentObj2.revision.length > 0"
                    target="_blank"
                    @click="showRevisinos()"
                  ><small style=" float: right; color: #c8a45f;">View Old Files?</small>
                  </a>
                  <validation-provider
                    #default="{ errors }"
                    name="revisions"
                    rules=""
                  >
                    <b-form-file
                      ref="revisions"
                      v-model="revisions"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                      multiple
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="completionForm">Completion Form</label>
                  <a
                    v-if="parentObj2 && parentObj2.completionForm"
                    :href="parentObj2 && parentObj2.completionForm && parentObj2.completionForm.url "
                    target="_blank"
                  ><small style=" float: right;">View Old File?</small></a>
                  <validation-provider
                    #default="{ errors }"
                    name="completionForm"
                    :rules="customRules"
                  >
                    <b-form-file
                      v-model="phaseTwo.completionForm"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                v-if="revisionBool === true"
                md="12"
              >
                <div class="card bg-light text-dark">
                  <div class="card-body">
                    <b-row
                      v-for="(item, key) in parentObj2.revision"
                      class="mb-1 file-card"
                    >
                      <b-col md="8">
                        <a
                          v-if="item && item.url"
                          :href="item && item.url"
                          target="_blank"
                          style="color: unset;"
                        >
                          {{ item.name }}.pdf</a>
                      </b-col>
                      <b-col
                        md="4"
                        class="align-end cursor-pointer"
                      >
                        <feather-icon
                          icon="XIcon"
                          size="16"
                          @click="deleteFile(item.id)"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <h4 class="mt-2 mb-1">
                  Design Types
                </h4>
                <app-collapse
                  v-for="(type, key) in designTypes"
                  accordion
                >
                  <app-collapse-item :title="type.model.name">
                    <validation-provider
                      #default="{ errors }"
                      :name="type.model.name"
                      rules=""
                    >
                      <vue-dropzone
                        :id="type.model.name"
                        :ref="`designType_${type.model.id}`"
                        :name="type.model.name"
                        :options="dropzoneOptions"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </app-collapse-item>
                </app-collapse>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                style="display: flex; justify-content: end;"
              >
                <button
                  id="submit-phase-2"
                  type="button"
                  class="btn btn-outline-primary mt-2"
                  @click.prevent="validationForm"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-25"
                  />
                  Submit
                </button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormDatepicker, BFormFile,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vue2Dropzone from 'vue2-dropzone'
import { codeBasic, codeAccordionDefault } from './code'
import designTypesService from '@/services/settings/designTypesService'
import phaseTwoService from '@/services/project/phaseTwoService'

import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import projectService from '@/services/projectService'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormFile,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    AppCollapse,
    AppCollapseItem,
    vueDropzone: vue2Dropzone,
  },
  props: ['phase', 'parentObj2'],
  data() {
    return {
      customRules: 'required',
      codeAccordionDefault,
      designTypes: [],
      loading: false,
      projectTypes: [],
      projectTypesTemp: [],
      projectStatus: [],
      projectStatusTemp: [],
      revisions: [],
      remainedRevision: [],
      revisionBool: false,
      phaseTwo: {
        startDate: '',
        plannedEndDate: '',
        actualEndDate: '',
        completionForm: null,
        revisions: {},
        designTypes: [],
      },
      designTypesImages: [],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        addRemoveLinks: true,
        dictRemoveFile: 'Remove',
        acceptedFiles: ".jpeg,.jpg,.png,.gif",
      },
      required,
      password,
      email,
      confirmed,
    }
  },
  mounted() {
    this.$watch(() => this.tab, val => {
      this.choosenTab = val
    })
    this.$watch(() => this.parentObj2, parentObj => {
      this.refreshDropzone()
      if (parentObj !== null) {
        this.designTypes = parentObj.designTypes
        for (let i = 0; i < parentObj.designTypes.length; i++) {
          this.designTypesImages.push({ id: '', uploaded: [], remained: [] })
        }
        this.phaseTwo = {
          startDate: parentObj.startDate,
          plannedEndDate: parentObj.plannedEndDate,
          actualEndDate: parentObj.actualEndDate,
          completionForm: null,
          revisions: [],
          designTypes: [],
        }

        // Initiate Dropzone With Images

        for (let i = 0; i < parentObj.designTypes.length; i++) {
          const refName = `designType_${parentObj.designTypes[i].model.id}`
          for (let j = 0; j < parentObj.designTypes[i].media.length; j++) {
            setTimeout(() => {
              this.$refs[refName][0].manuallyAddFile(parentObj.designTypes[i].media[j].file, parentObj.designTypes[i].media[j].url)
            }, 300)
          }
        }
      }
    })
  },
  created() {},
  methods: {
    deleteFile(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          phaseTwoService.delete(id).then(response => {
            if (response && response.status === 200) {
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: 'Your Items have been deleted.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              }).then(() => {
                this.loading = false
              })
            }
          }).catch(error => Promise.reject(error))
        } else if (result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            text: '',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.loading = false
        } else {
          this.loading = false
        }

        this.$emit('refreshPanel', 'true')

        this.refreshDropzone()
      })
    },
    showRevisinos() {
      if (this.revisionBool === false) {
        this.revisionBool = true
      } else {
        this.revisionBool = false
      }
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    refreshDropzone(){
      this.customRules = ''
      this.designTypesImages = []
      if (this.parentObj2 && this.parentObj2.designTypes) {
        for (let i = 0; i < this.parentObj2.designTypes.length; i++) {
          const refName = `designType_${this.parentObj2.designTypes[i].model.id}`
          for (let j = 0; j < this.parentObj2.designTypes[i].media.length; j++) {
            setTimeout(() => {
              this.$refs[refName][0].removeAllFiles()
            }, 300)
          }
        }
      }
    },
    validationForm() {

      // initilize revisions object which will pass through API
      this.remainedRevision = []
      if (this.parentObj2 && this.parentObj2.revision) {
        for (let r = 0; r < this.parentObj2.revision.length; r++) {
          this.remainedRevision.push(this.parentObj2.revision[r].id)
        }
      }
      this.phaseTwo.revisions = { uploaded: this.revisions, remained: this.remainedRevision }
      // initilize images of design type object which will pass through API
      for (let i = 0; i < this.designTypes.length; i++) {
        this.designTypesImages[i].id = this.designTypes[i].model.id

        const refName = `designType_${this.designTypes[i].model.id}`
        this.designTypesImages[i].uploaded = this.$refs[refName][0].getAcceptedFiles() ?? []

        const arr = this.$refs[refName][0].getRejectedFiles().map(el => el.id) ?? []
        this.designTypesImages[i].remained = arr
      }
      this.phaseTwo.designTypes = this.designTypesImages
      this.loading = true
      document.getElementById('submit-phase-2').setAttribute('disabled', 'disabled')

      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          phaseTwoService.post(this.$route.params.id, this.phaseTwo)
            .then(response => {
              if (response && response.status === 200) {
                this.revisions = [];
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Phase Two Is Updated Successfully !',
                  },
                })
              }
              this.refreshDropzone()
                this.$emit('refreshPanel', 'true')

              this.loading = false
            })
          setTimeout(function(){
            document.getElementById('submit-phase-2').removeAttribute('disabled')
          }, 5000);
        }
        else{
          document.getElementById('submit-phase-2').removeAttribute('disabled')
        }
      }).catch(error => {
        Promise.reject(error)
        setTimeout(function(){
          document.getElementById('submit-phase-2').removeAttribute('disabled')
        }, 5000);
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
.align-end{
  display: flex!important;
  justify-content: end!important;
}
.file-card{
  padding-top: 2%;
  padding-bottom: 2%;
  border: 1px dashed #b9b9b9;
}
</style>
